import * as React from 'react';
import {Card} from 'antd';
import './Error.css';
import {TFunction, useTranslation} from "@nic-react-i18n/core";

export enum ErrorLevel {
    WARNING = 'warning',
    ERROR = 'error'
}

interface ErrorProps {
    title: string;
    description?: string;
    level: ErrorLevel;
    error?: any;
    icon?: string;
    iconColor?: string;
    params?: string;
}

interface ErrorViewStatus {
    icon: string;
    color: string;
}

const errorIcon = (status: number): ErrorViewStatus => {
    let res: ErrorViewStatus = {icon: 'fa fa-exclamation-circle', color: 'orange'};

    if ((status === 401) || (status === 403)) {
        res = {icon: 'error-icon fal fa-shield', color: 'blue'};
    }  else {
        if (status >= 400 && status < 500 ) {
            res = {icon: 'error-icon fa fa-exclamation-circle', color: 'orange'};
        } else {
            if (status >= 500 && status < 600) {
                res = {icon: 'error-icon fa fa-exclamation-circle', color: 'red'};
            }
        }
    }
    return res;
};

const descriptionMessage = (error: any, t: TFunction): string => {
    const { status, statusText } = error;

    let dMessage = statusText;

    if (status >= 400 && status < 500 ) {
        if (status === 401) {
            dMessage += t('error.authenticated');
        } else {
            if (status === 403) {
                dMessage += t('error.authorized');
            }
        }
    } else {
        if (status >= 500 && status <= 600) {
            dMessage += t('error.server');
        }
    }

    return dMessage;
};

const Error: React.FC<ErrorProps> = (props) => {
const {t} = useTranslation()

        const { title, description, level, error, icon, iconColor, params } = props;

        const errorDescription =
            (description && t(description, {params: params}))
            || (error && descriptionMessage(error, t));
        let iconCss: string;

        if (error) {
            const iconInfo: ErrorViewStatus = errorIcon(error.status);
            iconCss = iconInfo.color + ' ' + iconInfo.icon;
        } else {
            iconCss = iconColor + ' ' + icon;
        }

        return (
            <div
                style={{display: 'flex', marginTop: '1vh', flexDirection: 'row', justifyContent: 'center'}}
                className={'error'}
            >
                <Card
                    style={{width: '30vw'}}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div
                            style={{
                                fontSize: '2rem',
                                width: '20%',
                                textAlign: 'center',
                            }}
                        >
                            <i className={iconCss} />
                        </div>
                        <div
                            style={{
                                width: '80%',
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',

                            }}
                        >
                            <div className={`level-${level}`}>
                                <div className={'error-title'}><span> {title}</span></div>
                                <div className={'description'}>{errorDescription}</div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );

}
export default Error